const tables = [
  {
    name: "Statement ID",
  },
  {
    name: "Bank Account",
  },
  {
    name: "Period",
  },
  {
    name: "Opening Balance",
  },
  {
    name: "Closing Balance",
  },
  {
    name: "Reconciled",
  },
  {
    name: "Status",
  },
  {
    name: "Uploaded",
  },
  {
    name: "Actions",
  },
];

export default tables;
